import React from 'react';
import ReactDOM from 'react-dom/client';
import './common/styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM
  .createRoot(document.getElementById('root') as HTMLElement)
  .render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
